import { splitId } from '../businessLogicService/splitIdsFromBackEnd';

/*export enum IndividualReportSource {
  TEACHER_DASHBOARD,
}*/

interface params {
  studentId: string;
  classIds?: string[];
}

export const getIndividualReportURL = (params: params) => {
  const clsIds = params.classIds?.map(cid => splitId(cid));
  if (!clsIds) {
    return `${params.studentId.includes('Node') ? splitId(params.studentId) : params.studentId}`;
  }
  return `${params.studentId.includes('Node') ? splitId(params.studentId) : params.studentId}/${clsIds?.join('-')}`;
};
